import { BaseEntity } from "@mp/common/entities/base.entity";
import { TeamEntity } from "@mp/common/entities/team.entity";
import { HoursRange } from "@mp/common/types/date.types";
import { MissionModel } from "@m481/mp-sdk-ng";

export const ALL_DAY_HOURS_VALUE = [[0]];

export interface MissionEntity extends BaseEntity {
    id: string;
    name: string;
    isRegular: boolean;
    color: string;
    allDay: boolean; //not in model
    hours: Array<HoursRange>;
    teamId: string;
    team?: TeamEntity;
    isEnabled?: boolean;
}

export class MissionEntityHelper {
    public static fromModel(missionModel: MissionModel): MissionEntity {
        const allDay = JSON.stringify(missionModel.hours) === JSON.stringify(ALL_DAY_HOURS_VALUE);
        return {
            id: missionModel.id,
            name: missionModel.name,
            isRegular: missionModel.isRegular,
            color: missionModel.color,
            allDay,
            hours: allDay ? [] : missionModel.hours.map(hour => ({ startTime: MissionEntityHelper.floatToTime(hour[0]), endTime: MissionEntityHelper.floatToTime(hour[1]) })),
            teamId: missionModel.teamId,
            team: undefined,
            isEnabled: missionModel?.isEnabled ?? true
        };
    }

    public static toModel(missionEntity: MissionEntity): MissionModel {
        return {
            id: missionEntity.id,
            name: missionEntity.name,
            isRegular: missionEntity.isRegular,
            color: missionEntity.color,
            hours:
                missionEntity.hours.length > 0
                    ? missionEntity.hours.map(hour => [MissionEntityHelper.timeToFloat(hour.startTime), MissionEntityHelper.timeToFloat(hour.endTime)])
                    : ALL_DAY_HOURS_VALUE,
            teamId: missionEntity.teamId,
            isEnabled: missionEntity?.isEnabled ?? true
        };
    }

    private static floatToTime(value: number): string {
        const hours = Math.floor(value);
        const minutes = Math.round((value - hours) * 60);
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    }

    private static timeToFloat(value: string): number {
        const [hours, minutes] = value.split(":").map(Number);
        return hours + minutes / 60;
    }
}
